import axios from "axios";
import api from "./apiURL";
import { baseURL } from "../config";
export const devURL = "https://devapi.ceviliyar.in";
export async function getRelationList() {
  try {
    const response = await api.get(`/api/v1/user/rm`);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function updateUserList(data) {
  try {
    const response = await api.post(`/api/v1/user/signup`, data);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function getServiceAreas() {
  try {
    const response = await api.get(`/api/v1/visit/service/areas`);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function sendNotification(data) {
  try {
    const response = await api.post(`/api/v1/admin/notification/send`, data);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function getHospitalList() {
  try {
    const response = await api.get(`/api/v1/admin/partner/getAll`);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function updateHospitalList(data) {
  try {
    const response = await api.post(`/api/v1/admin/partner/add`, data);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

// export async function updatePartner(data) {
//   try {
//     const response = await axios.post(
//       `${baseURL}/api/v1/admin/partner/add`,
//       data
//     );
//     return response.data;
//   } catch (error) {
//     // Handle the error
//     console.log(error);
//   }
// }
export async function contractSubmit(data) {
  try {
    const response = await api.put(`/api/v1/partner/contract/sign`, data);
    return response.data;
  } catch (error) {
    console.log("API call error:", error);
    return {
      error: true,
      message: error?.response?.data?.message || "Something went wrong.",
    };
  }
}

export async function updateInquiry(data) {
  try {
    const response = await axios.post(`${baseURL}/api/v1/inquiry/add`, data);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function getEnquiry(data) {
  try {
    const response = await axios.get(`${baseURL}/api/v1/inquiry/get`, data);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function addAdminUser(data) {
  try {
    const response = await api.post(
      `${baseURL}/api/v1/admin/manager/add`,
      data
    );
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function getAdminUsersList() {
  try {
    const response = await api.get(`/api/v1/admin/manager/get`);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function updateAdminStatus(user, data) {
  try {
    console.log(user, data);
    const response = await api.put(
      `/api/v1/admin/manager/status?id=${user?._id}`,
      data
    );
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function deleteAdminUser(user) {
  try {
    const response = await api.delete(
      `/api/v1/admin/manager/delete?id=${user?._id}`
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function updatePassword(data) {
  try {
    const response = await api.put("api/v1/admin/update/password", data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function verifyRedirect(code, state, error) {
  try {
    const response = await axios.get(
      `${baseURL}/api/v1/verify/aadhaar/callback?code=${code}&state=${state}&error=${error}`
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function DevVerifyRedirect(code, state, error) {
  try {
    const response = await axios.get(
      `${devURL}/api/v1/verify/aadhaar/callback?code=${code}&state=${state}&error=${error}`
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function addBulkList(data) {
  try {
    const response = await api.post(
      `${baseURL}/api/v1/admin/bulk/upload`,
      data
    );
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}


export async function getPartnerInfo(id) {
  console.log(id)
  try {
    const response = await api.get(`/api/v1/admin/partner/details?partnerID=${id}`);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}